import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { App } from "./app/App";
import "../src/i18n/config";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { MantineProvider } from "@mantine/core";
import { theme } from "./app/config/matine";
import { Notifications } from "@mantine/notifications";
import "@mantine/notifications/styles.css";
import "@mantine/dates/styles.css";
import "@gfazioli/mantine-onboarding-tour/styles.css";
import "@gfazioli/mantine-onboarding-tour/styles.layer.css";

const clientId = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <MantineProvider theme={theme}>
      <Notifications position="top-right" />

      <GoogleOAuthProvider clientId={clientId!}>
        <App />
      </GoogleOAuthProvider>
    </MantineProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();
